<template>
  <table
    class="custom_new_table"
    :style="[
      colCount > 9 ? { '--th-padding-x': '8px' } : {},
      colCount > 11 ? { '--th-padding-x': '0px' } : {},
    ]"
  >
    <thead ref="header">
      <slot name="header" />
    </thead>

    <tbody>
      <slot name="body" />
      <tr class="loading_tr" v-if="loading" v-for="x in 2" :key="x">
        <td v-for="i in colCount" :key="i">
          <shine-loading />
        </td>
      </tr>
      <tr v-else-if="isEmpty">
        <td :colspan="colCount" class="tw-text-center">{{ emptyLabel }}</td>
      </tr>
      <tr ref="endOfTable" v-if="canLoadMore && !loading && !isEmpty">
        <!--      v-if="canLoadMore && !loading"-->
        <td :colspan="colCount">
          <div
            class="tw-w-full tw-h-[200px] tw-grid tw-place-content-center"
          ></div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useIntersectionObserver } from '@vueuse/core'

import LoadingSpinner from '@/components/loading/LoadingSpinner.vue'
const header = ref(null)

const emit = defineEmits(['loadMore'])
const props = defineProps({
  loading: { type: Boolean, default: false },
  isEmpty: { type: Boolean, default: false },
  emptyLabel: { type: String, default: '' },
  canLoadMore: { type: Boolean, default: false },
})

const endOfTable = ref(null)

const colCount = computed(() => {
  return header.value?.querySelectorAll('th').length || 1
})

const { stop } = useIntersectionObserver(
  endOfTable,
  ([{ isIntersecting }], observerElement) => {
    if (isIntersecting && props.canLoadMore) {
      emit('loadMore')
    }
  },
)
</script>
<style>
:root {
  --th-padding-x: 16px;
}
.custom_new_table {
  width: 100%;
  border-spacing: 0;
}

.custom_new_table .mobile-title {
  @apply tw-inline-block tw-text-blue-dark-200 sm:tw-hidden;
}

.custom_new_table thead {
  @apply sm:tw-top-[196px] max-sm:tw-hidden tw-p-6 tw-text-sm tw-font-bold tw-bg-gray-50 tw-text-blue-dark-500 tw-static sm:tw-sticky tw-z-10;
}

.custom_new_table thead tr th {
  @apply tw-border-b tw-border-blue-dark-50;
}

.custom_new_table thead tr th {
  font-weight: 700;
  position: relative;
  background-color: #fbfcfc;
  text-wrap: nowrap;
}

.custom_new_table tbody tr td,
.custom_new_table thead tr th {
  @apply tw-text-blue-dark-500;
  font-size: 14px !important;
  border-color: #e8ebef !important;
  height: 64px !important;
  padding: 0 var(--th-padding-x);
  transition-duration: 0.28s;
  transition-property: box-shadow, opacity, background, height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.custom_new_table tbody tr:not(:last-child) td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.custom_new_table tbody {
  background-color: #fff !important;

  @apply tw-overflow-auto tw-text-sm;
}
.custom_new_table tbody tr {
  @apply tw-duration-300 max-sm:tw-grid max-sm:tw-border-dashed max-sm:tw-flex max-sm:tw-justify-between;
}

.custom_new_table tbody tr:not(.loading_tr) {
  @apply hover:tw-bg-primary-25;
}
.custom_new_table tbody tr.is-selected {
  @apply tw-bg-primary-25;
}
.custom_new_table tbody tr:not(.loading_tr) td {
  @apply tw-cursor-pointer;
}
.custom_new_table tbody tr td * {
  @apply tw-cursor-default;
}
.custom_new_table tbody tr td.number_if_rows {
  @apply tw-w-[87px];
}
.custom_new_table tbody tr td.number_if_rows > span {
  @apply tw-inline-flex tw-items-center tw-justify-center
  tw-min-w-[30px] tw-h-[30px] tw-px-1 tw-bg-blue-dark-50 tw-rounded-[4px];
}
.custom_new_table tbody tr td:last-child {
  @apply max-sm:tw-mb-3;
}
</style>
